import registerFocus from './custom/cyc' // 获取焦点
import dropUpload from './custom/dropUpload'
export default function registerDirectives(app) {
  registerFocus(app)
  dropUpload(app)
}
